import React from "react";
import { toast } from "sonner";
import { X, Copy } from "lucide-react";

/**
 * Shown once after admin creates a web user or resets a password.
 * The plaintext credential must be copied here — it is never surfaced again.
 */
export const OneShotPasswordModal = ({ email, password, note, onClose }) => (
  <div
    className="fixed inset-0 z-[70] flex items-center justify-center bg-slate-900/50 backdrop-blur-sm p-4"
    onClick={onClose}
  >
    <div
      onClick={(e) => e.stopPropagation()}
      className="w-full max-w-md rounded-md border border-amber-300 bg-white shadow-2xl"
      data-testid="oneshot-password-modal"
    >
      <div className="flex items-start justify-between border-b border-amber-200 bg-amber-50 px-6 py-4">
        <div>
          <div className="text-[10px] font-bold uppercase tracking-[0.2em] text-amber-800">
            Copy now — shown only once
          </div>
          <h3 className="font-heading text-lg font-bold text-slate-900">Temporary password</h3>
          <p className="mt-1 text-[11px] text-slate-600">
            For <b>{email}</b>. Share securely; user must change on first sign-in.
          </p>
        </div>
        <button onClick={onClose} className="rounded-md p-1.5 text-slate-500 hover:bg-slate-100">
          <X size={18} />
        </button>
      </div>
      <div className="px-6 py-5">
        <div className="flex items-center gap-2">
          <code
            className="flex-1 rounded-md border border-slate-200 bg-slate-50 px-3 py-2.5 font-mono text-sm text-slate-900 break-all"
            data-testid="oneshot-password-value"
          >
            {password}
          </code>
          <button
            onClick={() => {
              navigator.clipboard.writeText(password);
              toast.success("Copied");
            }}
            className="rounded-md border border-slate-200 bg-white p-2.5 text-slate-600 hover:text-nmi-700 hover:border-nmi-600"
            data-testid="oneshot-password-copy"
            aria-label="Copy password"
          >
            <Copy size={14} />
          </button>
        </div>
        {note && <p className="mt-3 text-[11px] text-slate-500">{note}</p>}
      </div>
      <div className="flex justify-end border-t border-slate-200 bg-slate-50 px-6 py-3">
        <button
          onClick={onClose}
          className="rounded-md bg-nmi-700 px-3 py-1.5 text-xs font-semibold text-white hover:bg-nmi-800"
        >
          Done
        </button>
      </div>
    </div>
  </div>
);

export default OneShotPasswordModal;
